import { Logger } from '@/utils/logging/logger';

export class LoggerFactory {
  static create () {
    return Logger;
  }
}
